/*---------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAPTURE_METADATA = false;
exports.IN_DEBUG_MODE = false;
//# sourceMappingURL=debug.js.map